import { useContext } from "react"
import ReactVisibilitySensor from "react-visibility-sensor"
import { LangContext } from "../../App"

const TitleBorderLeft = ({ children } : { children : JSX.Element | string }) => {
  const { lang } = useContext(LangContext);

  return (
    <ReactVisibilitySensor
        partialVisibility
    >
    {({isVisible} : any) => (
        <h2 className={`text-title-border-left ${lang ? "rtl" : ""} ${isVisible ? "visible" : ""}`}>
          {children}
        </h2>
    )}
    </ReactVisibilitySensor>
  )
}

export default TitleBorderLeft